<template>
    <div class="bg-light">
        <div class="body-wrapper">
            <backend-header />
            <loading-animation
                class="loading"
                v-show="loading"
            />
            <main v-show="!loading">
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{$t('Fatture')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="controlli-elenco mt-5 row d-flex justify-content-between align-items-center flex-wrap">
                        <div class="col-md-3">
                            <button
                                type="button"
                                class="btn btn-light border"
                                v-b-modal.popupricerca
                            >
                                {{$t('Ricerca con filtri')}}
                            </button>
                        </div>
                        <div class="row filters-labels col-md-12 mt-2">

                            <b-alert
                                dismissible
                                :show="searchInvoice.numOrdine !== ''"
                                @dismissed="clearFilter('numOrdine')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Ordine')}}: {{ searchInvoice.numOrdine }}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchInvoice.rifCliente !== ''"
                                @dismissed="clearFilter('rifCliente')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Rif. Cliente')}}: {{ searchInvoice.rifCliente }}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchInvoice.ragioneSociale !== ''"
                                @dismissed="clearFilter('ragioneSociale')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Ragione sociale')}}: {{ searchInvoice.ragioneSociale }}</small>
                            </b-alert>

                            <b-alert
                                dismissible
                                :show="searchInvoice.statoFattura !== 'all'"
                                @dismissed="clearFilter('statoFattura')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small v-if="+searchInvoice.statoFattura === 0">{{$t('Stato')}}: {{ $t('Non emesse') }}
                                </small>
                                <small v-if="+searchInvoice.statoFattura === 1">{{$t('Stato')}}: {{ $t('Emesse') }}
                                </small>
                            </b-alert>

                            <div class="align-middle mt-1">
                                <a
                                    class="ml-2"
                                    href=""
                                    v-if="searchInvoice.numOrdine !== '' || searchInvoice.rifCliente !== '' || searchInvoice.ragioneSociale !== ''
                                || searchInvoice.statoFattura !== 'all'"
                                    @click.prevent="clearFilter()"
                                >
                                    <small>{{$t('Pulisci tutti i filtri')}}</small>
                                </a>
                            </div>
                        </div>
                    </div>
                    <b-table
                        class="elenco-ordini tabella-responsive table table-striped mt-3 mb-0"
                        striped
                        id="invoices-table"
                        :per-page="pagination.perPage"
                        :current-page="pagination.currentPage"
                        :fields="tableHead"
                        :items="filteredInvoices"
                        :tbody-tr-class="rowClass"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <!-- TABLE BODY DATA -->
                        <template #cell(numOrdine)="data">
                            <a
                                href="javascript:void(0);"
                                @click="showInvoiceDetail(data.item)"
                            >
                                {{ data.item.numOrdine }}
                                <font-awesome-icon
                                    :icon="['fas', 'info-circle']"
                                    title="?"
                                    class="ml-1"
                                    @click="showInvoiceDetail(data.item)"
                                />
                            </a>
                        </template>
                        <template #cell(ragioneSociale)="data">
                            <span class="ragione-sociale"> {{ data.item.ragioneSociale }} </span>
                        </template>
                        <template #cell(rifCliente)="data">
                            <span class="rif-cliente"> {{ data.item.rifCliente }} </span>
                        </template>
                        <template #cell(nomeEvento)="data">
                            <span class="titolo-gallery"> {{ data.item.nomeEvento }} </span>
                        </template>
                        <template #cell(dataRicezioneOrdine)="data">
                            <span class="data-ricezione"> {{ data.item.dataRicezioneOrdine |formatDateSlash }} </span>
                        </template>
                        <template #cell(desStatoOrdine)="data">
                            <span class="stato-ordine"> {{ data.item.desStatoOrdine }} </span>
                        </template>
                        <template #cell(emessa)="data">
                            <span
                                v-if="+data.item.emessa === 1"
                                class="stato-fattura"
                            > {{ $t('Emessa') }} </span>
                            <span
                                v-if="+data.item.emessa === 0 && data.item.statoOrdine !== 'P'"
                                class="stato-fattura"
                            >
                                <!-- TODO - check stato ordine -->
                                <b-button
                                    class="btn btn-primary btn-rikorda1"
                                    @click="confirmInvoiceAsIssued(data.item)"
                                >
                                    {{ $t("Marca come EMESSA") }}
                                </b-button>
                            </span>
                        </template>
                    </b-table>
                    <nav
                        class="paginazione mt-3"
                        aria-label="Paginazione"
                    >
                        <b-pagination
                            v-model="pagination.currentPage"
                            :total-rows="paginationRows"
                            :per-page="pagination.perPage"
                            aria-controls="invoices-table"
                            align="right"
                            class="pagination justify-content-end mb-0"
                        />
                    </nav>
                </div>
            </main>
            <backend-footer />

            <!-- popup ricerca fatture -->
            <b-modal
                id="popupricerca"
                :title="$t('Cerca fatture')"
                @ok="onPopupRicercaOk"
            >
                <div class="form-group mt-1 mb-2">
                    <label
                        for="numOrdine"
                        class="mb-0"
                    >{{$t('Ordine')}} #</label>
                    <input
                        ref="popupRicercaOrdine"
                        type="text"
                        class="form-control"
                        name="numOrdine"
                        id="numOrdine"
                        :value="searchInvoice.numOrdine"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="rifCliente"
                        class="mb-0"
                    >{{$t('Rif. Cliente')}}</label>
                    <input
                        ref="popupRicercaCliente"
                        type="text"
                        class="form-control"
                        name="rifCliente"
                        id="rifCliente"
                        :value="searchInvoice.rifCliente"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="ragione-sociale"
                        class="mb-0"
                    >{{$t('Ragione sociale')}}</label>
                    <input
                        ref="popupRicercaRagioneSociale"
                        type="text"
                        class="form-control"
                        name="ragione-sociale"
                        id="ragione-sociale"
                        :value="searchInvoice.ragioneSociale"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="statoFattura"
                        class="mb-0"
                    >{{$t('Stato')}}</label>
                    <b-form-select
                        class="form-control"
                        name="statoFattura"
                        id="statoFattura"
                        ref="popupRicercaStatoFattura"
                        :value="searchInvoice.statoFattura"
                    >
                        <option value="all">{{$t('Tutte')}}</option>
                        <option value="1">{{$t('Emesse')}}</option>
                        <option value="0">{{$t('Non emesse')}}</option>
                    </b-form-select>
                </div>
                <template #modal-footer="{ok,cancel}">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Cerca") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup dettagli fattura -->
            <b-modal
                id="popupdettagli"
                :title="$t('Dati fattura per ordine num. ') + invoiceDetails.numOrdine"
                hide-footer
                centered
            >
                <div class="row">
                    <div class="col-md-6">{{ $t('Ragione sociale')}}: <p>{{ invoiceDetails.ragioneSociale }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Codice fiscale')}}: <p>{{ invoiceDetails.cf }}</p>
                    </div>
                    <div
                        class="col-md-12"
                        v-if="invoiceDetails.piva"
                    >{{ $t('Partita IVA')}}:
                        <p>{{ invoiceDetails.piva }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Indirizzo')}}: <p>{{ invoiceDetails.indirizzo }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Città')}}: <p>{{ invoiceDetails.citta }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Provincia')}}: <p>{{ invoiceDetails.provincia }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Cap')}}: <p>{{ invoiceDetails.cap }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Indirizzo')}}: <p>{{ invoiceDetails.indirizzo }}</p>
                    </div>
                    <div class="col-md-6">{{ $t('Città')}}: <p>{{ invoiceDetails.citta }}</p>
                    </div>
                    <div
                        class="col-md-12"
                        v-if="invoiceDetails.tel"
                    >{{ $t('Telefono')}}:
                        <p>{{ invoiceDetails.tel }}</p>
                    </div>
                    <div
                        class="col-md-6"
                        v-if="invoiceDetails.pec"
                    >{{ $t('Pec')}}:
                        <p>{{ invoiceDetails.pec }}</p>
                    </div>
                    <div
                        class="col-md-6"
                        v-if="invoiceDetails.codiceIdentificativo"
                    >{{ $t('Codice identificativo')}}:
                        <p>{{ invoiceDetails.codiceIdentificativo }}</p>
                    </div>
                </div>
            </b-modal>

            <!-- popup conferma fattura emessa -->
            <b-modal
                id="popupfatturaemessa"
                hide-header
                centered
                @ok="markInvoiceAsIssued"
            >
                <p class="my-4">
                    {{$t('Sei sicuro di voler marcare la fattura num. ' + issuingInvoice.numOrdine + ' come emessa?')}}
                </p>
                <template #modal-footer="{ok,cancel}">
                    <b-button
                        class="btn btn-light border danger"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Conferma") }}
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";
import LoadingAnimation from "../../../components/LoadingAnimation";

export default {
    name: "BackendSalesInvoices",
    components: {
        LoadingAnimation,
        BackendHeader,
        BackendFooter
    },
    data() {
        return {
            loading: false,
            invoices: {},
            filteredInvoices: [],
            tableHead: [
                {
                    key: "numOrdine",
                    label: "# Ordine",
                    tdAttr: { "data-title": "Ordine #" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "ragioneSociale",
                    label: "Ragione Sociale",
                    tdAttr: { "data-title": "Ragione Sociale" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "rifCliente",
                    label: "Rif. Cliente",
                    tdAttr: { "data-title": "Rif. Cliente" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "nomeEvento",
                    label: "Gallery",
                    tdAttr: { "data-title": "Gallery" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "dataRicezioneOrdine",
                    label: "Data",
                    tdAttr: { "data-title": "Data" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "desStatoOrdine",
                    label: "Stato",
                    tdAttr: { "data-title": "Stato" },
                    tdClass: "align-middle px-1",
                    sortable: true
                },
                {
                    key: "emessa",
                    label: "Emessa",
                    tdAttr: { "data-title": "Emessa" },
                    tdClass: "align-middle px-1"
                }
            ],
            sortBy: "dataRicezioneOrdine",
            sortDesc: true,
            searchInvoice: {
                numOrdine: "",
                rifCliente: "",
                ragioneSociale: "",
                statoFattura: "0"
            },
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            invoiceDetails: {},
            issuingInvoice: {}
        };
    },
    computed: {
        paginationRows() {
            return this.filteredInvoices.length;
        }
    },
    methods: {
        onPopupRicercaOk() {
            this.searchInvoice.numOrdine = this.$refs.popupRicercaOrdine.value;
            this.searchInvoice.rifCliente =
                this.$refs.popupRicercaCliente.value;
            this.searchInvoice.ragioneSociale =
                this.$refs.popupRicercaRagioneSociale.value;
            this.searchInvoice.statoFattura =
                this.$refs.popupRicercaStatoFattura.$el.value;
            this.filterCustom();
        },
        filterCustom() {
            this.filteredInvoices = this.invoices.filter((invoice) => {
                return (
                    invoice.numOrdine.includes(this.searchInvoice.numOrdine) &&
                    invoice.rifCliente
                        .toLowerCase()
                        .includes(
                            this.searchInvoice.rifCliente.toLowerCase()
                        ) &&
                    invoice.ragioneSociale
                        .toLowerCase()
                        .includes(
                            this.searchInvoice.ragioneSociale.toLowerCase()
                        ) &&
                    (+invoice.emessa === +this.searchInvoice.statoFattura ||
                        this.searchInvoice.statoFattura === "all")
                );
            });
        },
        clearFilter(filter) {
            switch (filter) {
                case "numOrdine":
                    this.searchInvoice.numOrdine = "";
                    this.filterCustom();
                    break;
                case "rifCliente":
                    this.searchInvoice.rifCliente = "";
                    this.filterCustom();
                    break;
                case "ragioneSociale":
                    this.searchInvoice.ragioneSociale = "";
                    this.filterCustom();
                    break;
                case "statoFattura":
                    this.searchInvoice.statoFattura = "all";
                    this.filterCustom();
                    break;
                default:
                    this.searchInvoice.numOrdine = "";
                    this.searchInvoice.rifCliente = "";
                    this.searchInvoice.ragioneSociale = "";
                    this.searchInvoice.statoFattura = "all";
                    this.filterCustom();
                    break;
            }
        },
        showInvoiceDetail(invoice) {
            this.invoiceDetails = invoice;
            this.$bvModal.show("popupdettagli");
        },
        rowClass(item) {
            return +item.emessa === 1
                ? "ordine mt-0 table-success"
                : "ordine mt-0";
        },
        confirmInvoiceAsIssued(invoice) {
            this.issuingInvoice = invoice;
            this.$bvModal.show("popupfatturaemessa");
        },
        markInvoiceAsIssued() {
            let _this = this;
            this.$api
                .backendMarkInvoiceAsIssued(_this.issuingInvoice.idFattura)
                .then((result) => {
                    if (result.status === "success") {
                        _this.invoices.forEach((invoice, index) => {
                            _this.invoices[index]["emessa"] =
                                _this.issuingInvoice.idFattura ===
                                invoice.idFattura
                                    ? "1"
                                    : _this.invoices[index]["emessa"];
                        });
                        _this.filteredInvoices.forEach((invoice, index) => {
                            _this.filteredInvoices[index]["emessa"] =
                                _this.filteredInvoices.idFattura ===
                                invoice.idFattura
                                    ? "1"
                                    : _this.filteredInvoices[index]["emessa"];
                        });
                        _this.filterCustom();
                        _this.issuingInvoice = {};
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_MARK_INVOICE_AS_ISSUED", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        }
    },
    mounted: function () {
        this.loading = true;
        this.$api
            .backendGetInvoices()
            .then((result) => {
                console.debug("BACKEND_GET_INVOICES", result);
                this.invoices = result.invoices;
                this.filteredInvoices = this.invoices;
                this.filterCustom();
            })
            .catch((error) => {
                console.error("BACKEND_GET_INVOICES", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
};
</script>

<style scoped>
</style>
